<script>
import { CellGroup, Cell, Row, Col, Image, Icon, Tag, Grid, GridItem, Toast, Dialog } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-icon': Icon,
        'van-tag': Tag,
        'van-grid': Grid,
        'van-grid-item': GridItem,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                id: null,
                organizationId: null,
                name: null,
                logoUrl: null, 
                status: null,
                publishStatus: null,
                matchGroupId: null,
                isSignupOn: null,
                authStatus: null,
            },
            role: {
                isManager: null,
                isReferee: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        matchStatusField() {
            const matchStatus = this.match.status ? this.match.status : 1
            return this.locale.localeProp ? this.locale.localeProp('match-status-option-' + matchStatus) : ''
        },
        matchPublishStatusField() {
            const matchPublishStatus = this.match.publishStatus ? this.match.publishStatus : 1
            return this.locale.localeProp ? this.locale.localeProp('match-publish-status-option-' + matchPublishStatus) : ''
        },
        matchPublishStatusTag() {
            if (this.locale.localeProp) {
                if (this.match.publishStatus == '1') {
                    return {
                        label: this.locale.localeProp('match-publish-status-option-' + this.match.publishStatus),
                        color: '#FDE8D4',
                        textColor: '#F78C27',
                        isLink: true
                    }
                }
                else {
                    return {
                        label: this.locale.localeProp('match-publish-status-option-' + this.match.publishStatus),
                        color: '#DBECFD',
                        textColor: '#4AA2F7',
                        isLink: true
                    }
                }
            }
            return {}
        },
        matchBottomLabels() {
            return [
                { type: 'support-match', icon: 'service', label: this.locale['advisor-service'] },
                { type: 'preview-match', iconType: 'vant', icon: 'eye-o', label: this.locale['preview-match'] },
            ]
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onMoreBtnClick() {
            console.log('onMoreBtnClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatch',
                    params: {
                        id: this.match.id
                    }
                }
            })
        },
        onRefereeGroupBtnClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchReferee',
                    params: {
                        id: this.match.id
                    },
                    query: {
                        organizationId: this.match.organizationId
                    }
                }
            })
        },
        onStaffGroupBtnClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchStaff',
                    params: {
                        id: this.match.id
                    },
                    query: {
                        organizationId: this.match.organizationId
                    }
                }
            })
        },
        onTodoItemClick() {
            Toast(this.locale['coming-soon'])
        },
        onBottomLabelClick(type) {
            if (type == 'support-match') {
                this.onServiceBtnClick()
            }
            else if (type == 'preview-match') {
                this.onPreviewBtnClick()
            }
        },
        onPreviewBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: process.env.VUE_APP_BM_MATCH + '#/union-match/match-overall?preview=1&unionMatchId=' + this.match.id
                }
            })
        },
        onServiceBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: 'https://www.snsports.cn/webapplt/index/index.html#/customer-service/bd-agent'
                }
            })
        },
        onRuleItemClick() {
            console.log('onRuleItemClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchRule',
                    params: {
                        id: this.match.matchGroupId
                    },
                    query: {
                        matchId: this.match.id
                    }
                }
            })
        },
        onTeamItemClick() {
            console.log('onRuleItemClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchTeam',
                    params: {
                        id: this.match.matchGroupId
                    },
                    query: {
                        matchId: this.match.id
                    }
                }
            })
        },
        onScheduleItemClick() {
            console.log('onScheduleItemClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageMatchSchedule',
                    params: {
                        id: this.match.matchGroupId
                    },
                    query: {
                        matchId: this.match.id
                    }
                }
            })
        },
        onSignupPaymentItemClick() {
            console.log('onSignupPaymentItemClick')
            if (!this.validateManager()) {
                return
            }
            if (this.match.authStatus == '1' && !this.match.isSignupOn) {
                // prompt to authenticate the organization
                Dialog.confirm({
                    title: this.locale['open-signup'],
                    message: this.locale['open-signup-confirm-message'],
                    confirmButtonText: this.locale['go-auth'],
                }).then(() => {
                    // on confirm
                    // navigate to the organization detail page with auth tab
                    this.$emit('custom-event', {
                        type: 'navigate',
                        data: {
                            name: 'OrgDetailOrganization',
                            params: {
                                id: this.match.organizationId
                            },
                            query: {
                                tab: 1
                            }
                        }
                    })
                }).catch(() => {
                    // on cancel
                })
            }
            else if (this.match.isSignupOn) {
                // go to the sign up and payment page
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgManageMatchSignupPayment',
                        params: {
                            id: this.match.id
                        }
                    }
                })
            }
        },
        onSuspensionReminderItemClick() {
            console.log('onSuspensionReminderItemClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSuspensionReminder',
                    params: {
                        id: this.match.matchGroupId
                    }
                }
            })
        },
        onPublishBtnClick() {
            console.log('onPublishBtnClick')
            if (!this.validateManager()) {
                return
            }
            const matchPublishStatus = this.match.publishStatus ? this.match.publishStatus : '1'
            Dialog.confirm({
                title: this.locale['switch-match-' + matchPublishStatus],
                message: this.locale['switch-match-confirm-message-' + matchPublishStatus]
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'submit',
                    data: {
                        id: this.match.id,
                        publishStatus: (matchPublishStatus == '1' ? '2' : '1')
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateManager() {
            console.log('validateManager', this.role.isManager)
            if (this.role.isManager) {
                return true
            }
            else {
                Toast(this.locale['no-permission'])
                return false
            }
        }
    },
}
</script>

<template>
    <div class="org-match-manage">
        <div class="b-outer-margin">
            <van-cell class="summary">
                <van-row>
                    <van-col class="vertical-center r-outer-margin">
                        <van-image
                            v-if="match.logoUrl"
                            :src="adjustImageSize(match.logoUrl, 100, 100)"
                            center
                            fit="cover" 
                            width="50px" 
                            height="50px"
                        />
                        <img
                            v-else
                            src="@/assets/org/logo-symbol.png" 
                            style="width: 50px; height: 50px;"
                        />
                    </van-col>
                    <van-col class="r-outer-margin">
                        <div class="match-info b-inner-margin">
                            <span class="main-text van-ellipsis block">{{ match.name }}</span>
                        </div>
                        <div class="text-left">
                            <van-tag>{{ matchStatusField }}</van-tag>
                        </div>
                    </van-col>
                    <div class="more-btn">
                        <van-icon 
                            name="more-o" 
                            size="24px"
                            @click.stop="onMoreBtnClick"
                        />
                    </div>
                </van-row>
            </van-cell>
            <van-cell class="groups">
                <van-row type="flex" justify="center" class="text-center">
                    <van-col span="8" class="van-hairline--right" @click="onRefereeGroupBtnClick">
                        <span class="minor-text minor-color">{{ locale['referee-group'] }}</span>
                    </van-col>
                    <van-col span="8" class="van-hairline--right" @click="onStaffGroupBtnClick">
                        <span class="minor-text minor-color">{{ locale['staff-group'] }}</span>
                    </van-col>
                    <van-col span="8">
                        <span class="minor-text minor-color">{{ locale['sponsor-group'] }}</span>
                    </van-col>
                </van-row>
            </van-cell>
        </div>
        <div class="functional-grid b-outer-margin">
            <van-grid :border="false">
                <van-grid-item :text="locale['match-group']" @click="onTodoItemClick"
                >
                    <template #icon>
                        <img src="@/assets/org/match-group-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['rule']" @click="onRuleItemClick">
                    <template #icon>
                        <img src="@/assets/org/rule-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['team']" @click="onTeamItemClick">
                    <template #icon>
                        <img src="@/assets/org/team-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['match-schedule']" @click="onScheduleItemClick">
                    <template #icon>
                        <img src="@/assets/org/match-schedule-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['signup-payment']" @click="onSignupPaymentItemClick">
                    <template #icon>
                        <img src="@/assets/org/signup-payment-icon.svg"/>
                        <div v-if="match.isSignupOn" class="item-status opened justify-center vertical-center">
                            <span class="support-text color-white lhn">{{ locale['opened'] }}</span>
                        </div>
                        <div v-else class="item-status closed justify-center vertical-center">
                            <span class="support-text color-white lhn">{{ locale['closed'] }}</span>
                        </div>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['suspension-reminder']" @click="onSuspensionReminderItemClick">
                    <template #icon>
                        <img src="@/assets/org/suspension-reminder-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['registration']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/registration-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['draw-cuts']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/draw-cuts-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['record-stats']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/record-stats-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['announcement']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/announcement-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['vote']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/vote-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['prize']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/assets/org/prize-icon.svg"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div class="added-service-grid b-outer-margin">
            <van-cell-group>
                <van-cell :title="locale['player-card']" @click="onTodoItemClick">
                    <template #icon>
                        <img 
                            class="r-outer-margin"
                            src="@/assets/org/player-card-icon.svg"
                        />
                    </template>
                </van-cell>
                <van-cell :title="locale['intro-video']" @click="onTodoItemClick">
                    <template #icon>
                        <img 
                            class="r-outer-margin"
                            src="@/assets/org/intro-video-icon.svg"
                        />
                    </template>
                </van-cell>
                <van-cell :title="locale['match-stats']" @click="onTodoItemClick">
                    <template #icon>
                        <img 
                            class="r-outer-margin"
                            src="@/assets/org/match-stats-icon.svg"
                        />
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
        <bottom-toolbar 
            type="tag-labels" 
            :minorTag="matchPublishStatusTag"
            :mainLabels="matchBottomLabels"
            @click-minor-tag="onPublishBtnClick"
            @click-main-label="onBottomLabelClick"
        />
    </div>
</template>

<style scoped>
.match-info {
    max-width: 260px;
}
.more-btn {
    position: absolute;
    right: 0;
    top: 16px;
}
.item-status {
    position: absolute;
    top: -6px;
    right: -10px;
    width: 29px;
    height: 14px;
    border-radius: 8px;
}
.item-status.closed {
    background: #2F3734;
}
.item-status.opened {
    background: #F7B227;
}
</style>